import angular from 'angular'
import './coinproduct_cash.service'

angular
  .module('admin.coinproduct_cash', ['admin.coinproduct_cash.service'])
  .controller('CoinProductsCashAdminCtrl', CoinProductsCashAdminCtrl)

/** @ngInject */
function CoinProductsCashAdminCtrl($scope, $state, $stateParams, $timeout, CoinProductCashService) {
  var vm = this
  vm.itemsActive = []
  vm.itemsInactive = []
  vm.itemsArchived = []
  vm.userId = $stateParams.parentId

  function reloadPaginationInactive() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationActive() {
    vm.totalUsers2 = 0
    vm.perPage2 = 25
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalUsers3 = 0
    vm.perPage3 = 25
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  vm.sortType = 'price-desc'
  vm.sortReverse = true
  vm.sortType2 = 'price-desc'
  vm.sortReverse2 = true
  vm.sortType3 = 'price-desc'
  vm.sortReverse3 = true

  var tab = localStorage.getItem('tabcoinproduct')
  if (tab !== null) {
    if (tab === 'active') {
      $('#inactive').removeClass('active')
      $('#active').addClass('active')
      $('#activetab').addClass('active')
      $('#archived').removeClass('active')
    } else {
      $('#active').removeClass('active')
      $('#inactive').addClass('active')
      $('#inactivetab').addClass('active')
      $('#archived').removeClass('active')
    }
  } else {
    $('#active').addClass('active')
    $('#activetab').addClass('active')
  }

  reloadPaginationActive()
  reloadPaginationInactive()
  reloadPaginationArchived()
  loadActive(1)
  loadInactive(1)
  loadArchived(1)

  var oldSortType
  function loadInactive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    CoinProductCashService.listInactiveBy(vm.oldPage, 25, vm.sortType).then(success)

    function success(result) {
      var items = result.results
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-p']) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x']) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )

          items[i].expired = items[i]['ts-x'] < new Date()
        }
      }

      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      vm.sortType = oldSortType
      vm.itemsInactive = result.results
    }
  }

  var oldSortType2
  function loadActive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    CoinProductCashService.listActiveBy(vm.oldPage2, 25, vm.sortType2).then(success)

    function success(result) {
      var items = result.results
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-p']) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x']) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      vm.sortType2 = oldSortType2
      vm.itemsActive = result.results
    }
  }

  var oldSortType3
  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    oldSortType3 = angular.copy(vm.sortType3)
    CoinProductCashService.listArchivedBy(vm.oldPage3, 25, vm.sortType3).then(success)

    function success(result) {
      var items = result.results
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-p']) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x']) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      vm.sortType3 = oldSortType3
      vm.itemsArchived = result.results
    }
  }

  vm.pageChangeInactive = function (newPage) {
    vm.sortType = oldSortType
    loadInactive(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangeActive = function (newPage) {
    vm.sortType2 = oldSortType2
    loadActive(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangeArchived = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.tabInactive = function () {
    $('#active').removeClass('active')
    $('#inactive').addClass('active')
    $('#archived').removeClass('active')
    localStorage.setItem('tabcoinproduct', 'inactive')
  }

  vm.tabActive = function () {
    $('#inactive').removeClass('active')
    $('#active').addClass('active')
    $('#archived').removeClass('active')
    localStorage.setItem('tabcoinproduct', 'active')
  }

  vm.tabArchived = function () {
    $('#inactive').removeClass('active')
    $('#active').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('tabcoinproduct', 'archived')
  }

  vm.publish = function (id) {
    var date = parseInt(new Date().getTime() + '000')
    CoinProductCashService.update(id, { 'ts-p': date }).then(function () {
      CoinProductCashService.publish(id).then(function () {
        reloadPaginationActive()
        reloadPaginationInactive()
        reloadPaginationArchived()
        loadActive(1)
        loadInactive(1)
        loadArchived(1)
      })
    })
  }

  vm.unpublish = function (id) {
    CoinProductCashService.unpublish(id).then(function () {
      reloadPaginationActive()
      reloadPaginationInactive()
      reloadPaginationArchived()
      loadActive(1)
      loadInactive(1)
      loadArchived(1)
    })
  }

  vm.archive = function (id) {
    CoinProductCashService.archive(id).then(function () {
      reloadPaginationActive()
      reloadPaginationInactive()
      reloadPaginationArchived()
      loadActive(1)
      loadInactive(1)
      loadArchived(1)
    })
  }

  vm.add = function () {
    $state.go('admin.product.edit', { id: 0, type: 'cash' })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          CoinProductCashService.remove(item.id).then(
            function () {
              reloadPaginationActive()
              reloadPaginationInactive()
              loadActive(1)
              loadInactive(1)
            },
            function () {
              $timeout(function () {
                swal(
                  "You can't delete this coin product because has products associated with it",
                  '',
                  'error',
                )
              }, 300)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.edit = function (item) {
    $state.go('admin.product.edit', { id: item.id, type: 'cash' })
  }

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    loadInactive(vm.pagination.current)
  }

  vm.sort2 = function (type) {
    vm.sortReverse2 = !vm.sortReverse2
    if (vm.sortReverse2) {
      vm.sortType2 = type + '-asc'
    } else {
      vm.sortType2 = type + '-desc'
    }
    loadActive(vm.pagination2.current)
  }

  vm.sort3 = function (type) {
    vm.sortReverse3 = !vm.sortReverse3
    if (vm.sortReverse3) {
      vm.sortType3 = type + '-asc'
    } else {
      vm.sortType3 = type + '-desc'
    }
    loadArchived(vm.pagination3.current)
  }
}
